if (!customElements.get('christmas-countdown-banner')) {
  class ChristmasCountdownBanner extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-countdown-ready')) return;

      this.setAttribute('data-countdown-ready', '');
      this.endDate = new Date(this.dataset.endDate || '');

      if (Number.isNaN(this.endDate.getTime())) {
        this.setAttribute('data-countdown-invalid', '');
        return;
      }

      this.units = {
        days: this.querySelector('[data-countdown-days]'),
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
        seconds: this.querySelector('[data-countdown-seconds]'),
      };

      this.updateCountdown();
      this.timer = window.setInterval(() => this.updateCountdown(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    format(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    }

    updateCountdown() {
      const distance = this.endDate.getTime() - Date.now();

      if (distance <= 0) {
        this.renderValues(0, 0, 0, 0);
        this.handleExpiredState();
        window.clearInterval(this.timer);
        return;
      }

      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);

      this.renderValues(days, hours, minutes, seconds);
      this.setAttribute(
        'aria-label',
        `${days} days, ${hours} hours, ${minutes} minutes${this.units.seconds ? `, ${seconds} seconds` : ''} remaining`,
      );
    }

    renderValues(days, hours, minutes, seconds) {
      if (this.units.days) this.units.days.textContent = this.format(days);
      if (this.units.hours) this.units.hours.textContent = this.format(hours);
      if (this.units.minutes) this.units.minutes.textContent = this.format(minutes);
      if (this.units.seconds) this.units.seconds.textContent = this.format(seconds);
    }

    handleExpiredState() {
      if (this.hasAttribute('data-countdown-expired')) return;

      this.setAttribute('data-countdown-expired', '');
      const mode = this.dataset.expiredMode || 'message';

      if (mode === 'hide_countdown') {
        this.querySelector('[data-countdown-box]')?.setAttribute('hidden', '');
      } else if (mode === 'hide_section') {
        this.setAttribute('hidden', '');
      } else if (mode === 'message') {
        this.querySelector('[data-countdown-units]')?.setAttribute('hidden', '');
        this.querySelector('[data-countdown-message]')?.removeAttribute('hidden');
      }
    }
  }

  customElements.define('christmas-countdown-banner', ChristmasCountdownBanner);
}
